/**
 * Email Service
 * PROTEGE QV Lecture+ — Firebase "Trigger Email from Firestore" Extension pattern
 *
 * Documents written to the `mail` collection are picked up by the
 * Firebase "Trigger Email" Extension and sent automatically.
 * Install the extension from: https://extensions.dev/extensions/firebase/firestore-send-email
 */

import { saveDocument } from './firestoreService.js';

const ADMIN_EMAIL = import.meta.env.VITE_ADMIN_EMAIL || 'mail@protegeqv.org';

/**
 * Queue an email to the admin via Firestore.
 * @param {string} subject
 * @param {string} html
 */
export const sendAdminEmail = async (subject, html) => {
  await saveDocument('mail', {
    to: [ADMIN_EMAIL],
    message: { subject, html },
  });
};
